'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import Tabs from 'DesignManagerIde/containers/Tabs';
import AllTabsMenu from 'DesignManagerIde/containers/AllTabsMenu';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';

class FinderTabs extends Component {
  renderFinderToggleButton() {
    const {
      isFinderShowing,
      onFinderToggleButtonClick
    } = this.props;
    const className = "finder-toggle-button p-all-2";
    const iconName = isFinderShowing ? 'first' : 'folder';
    return /*#__PURE__*/_jsx(UIIconButton, {
      className: className,
      onClick: onFinderToggleButtonClick,
      use: "transparent",
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: iconName,
        size: "xxs"
      })
    });
  }
  /* TODO: Adds this back in once a place has been chosen */


  renderKeyboardShortcutsButton() {
    return /*#__PURE__*/_jsx(UIBox, {
      className: "keybinding-shortcuts-listing-toggle-container",
      grow: 0,
      shrink: 0,
      children: /*#__PURE__*/_jsx(UIIconButton, {
        className: "p-all-2",
        onClick: (...partialArgs) => this.props.setIsKeyboardShortcutsListingShowing(true, ...partialArgs),
        use: "transparent",
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "info",
          size: "xxs"
        })
      })
    });
  }

  render() {
    return /*#__PURE__*/_jsxs(UIFlex, {
      align: "stretch",
      className: "tabs-container",
      direction: "row",
      wrap: "nowrap",
      children: [/*#__PURE__*/_jsx(UIBox, {
        className: "finder-toggle-container",
        grow: 0,
        shrink: 0,
        children: this.renderFinderToggleButton()
      }), /*#__PURE__*/_jsx(Tabs, {
        openContextMenu: this.props.openContextMenu
      }), /*#__PURE__*/_jsx(UIBox, {
        className: "all-tabs-container",
        grow: 0,
        shrink: 0,
        children: /*#__PURE__*/_jsx(AllTabsMenu, {})
      })]
    });
  }

}

FinderTabs.propTypes = {
  openContextMenu: PropTypes.func.isRequired,
  isFinderShowing: PropTypes.bool.isRequired,
  onFinderToggleButtonClick: PropTypes.func.isRequired,
  setIsKeyboardShortcutsListingShowing: PropTypes.func.isRequired
};
export default FinderTabs;